import { render, staticRenderFns } from "./phoneMenu.vue?vue&type=template&id=0b432250&scoped=true&"
import script from "./phoneMenu.vue?vue&type=script&lang=js&"
export * from "./phoneMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b432250",
  null
  
)

export default component.exports